import React from 'react';
import { useAppStore } from '../store/useAppStore';
import { TermsModal } from './modals/TermsModal';
import { PrivacyModal } from './modals/PrivacyModal';
import { EthicsModal } from './modals/EthicsModal';
import { DisclaimerModal } from './modals/DisclaimerModal';
import { LegalModalFrame } from './modals/LegalModalFrame';
import { SettingsModal } from './modals/SettingsModal';
import { ProfileModal } from './modals/ProfileModal';
import { HistoryModal } from './modals/HistoryModal';
import { UpgradeModal } from './modals/UpgradeModal';
import { ApiKeysModal } from './modals/ApiKeysModal';
import { AnalyticsModal } from './modals/AnalyticsModal';
import { UserAssetsModal } from './modals/UserAssetsModal';
import { AppAssetsModal } from './modals/AppAssetsModal';
import { AssetsGalleryModal } from './modals/AssetsGalleryModal';
import { InsufficientCreditsModal } from './modals/InsufficientCreditsModal';
import { ErrorModal } from './modals/ErrorModal';

export const ModalContainer: React.FC = () => {
  const { activeModal, errorModalTitle, errorModalMessage, closeModal } = useAppStore();

  const renderModal = () => {
    switch (activeModal) {
      case 'disclaimer':
        return <DisclaimerModal />;
      case 'terms':
        return <TermsModal />;
      case 'privacy':
        return <PrivacyModal />;
      case 'ethics':
        return <EthicsModal />;
      case 'settings':
        return <SettingsModal />;
      case 'profile':
        return <ProfileModal />;
      case 'history':
        return <HistoryModal />;
      case 'upgrade':
        return <UpgradeModal />;
      case 'apiKeys':
        return <ApiKeysModal isOpen={true} onClose={() => {}} />;
      case 'analytics':
        return <AnalyticsModal />;
      case 'userAssets':
        return <UserAssetsModal isOpen={true} onClose={() => {}} userId="" userName="" />;
      case 'appAssets':
        return <AppAssetsModal isOpen={true} onClose={() => {}} appId="" appName="" assetCount={0} />;
      case 'assetsGallery':
        return <AssetsGalleryModal isOpen={true} onClose={() => {}} onSelectAsset={() => {}} />;
      case 'insufficientCredits':
        return <InsufficientCreditsModal />;
      case 'error':
        return (
          <ErrorModal
            isOpen={true}
            onClose={() => {
              closeModal();
              window.location.reload();
            }}
            title={errorModalTitle || undefined}
            message={errorModalMessage || undefined}
          />
        );
      default:
        return null;
    }
  };

  if (!activeModal) return null;

  const inner = renderModal();
  if (!inner) return null;

  if (
    activeModal === 'disclaimer' ||
    activeModal === 'terms' ||
    activeModal === 'privacy' ||
    activeModal === 'ethics'
  ) {
    return <LegalModalFrame>{inner}</LegalModalFrame>;
  }

  return inner;
};
